export default __webpack_public_path__ + "static/media/min1.ebc1caae.JPG";